/* eslint-disable max-len */
/**
 * French translations.
 */
export default {
  ACTION: {
    LINK_COPY: 'Copier'
  },
  ERROR: {},
  HEADER: {
    NAME: 'Nom'
  },
  LABEL: {
    FILTER_MONTH_APR: 'Avril',
    FILTER_MONTH_AUG: 'Août',
    FILTER_MONTH_DEC: 'Décembre',
    FILTER_MONTH_FEB: 'Février',
    FILTER_MONTH_JAN: 'Janvier',
    FILTER_MONTH_JUL: 'Juillet',
    FILTER_MONTH_JUN: 'Juin',
    FILTER_MONTH_MAR: 'Mars',
    FILTER_MONTH_MAY: 'Mai',
    FILTER_MONTH_NOV: 'Novembre',
    FILTER_MONTH_OCT: 'Octobre',
    FILTER_MONTH_SEP: 'Septembre',
    GENERATE_HASHTAG: 'Générer un hashtag',
    GENERATE_LINK: 'Générer un lien',
    GENERATED_HASHTAG: 'Hashtag généré',
    GENERATED_LINK: 'Lien généré',
    MONTH: 'Mois',
    NAME: 'Nom',
    YEAR: 'Année'
  },
  SENTENCE: {
    NO_ROWS_PRODUCTS: 'Aucun produit',
    NO_ROWS_PRODUCTS_DESCRIPTION: 'Modifie les critères de recherche'
  },
  SUCCESS: {
    HASHTAG_COPIED: 'Hashtag copié',
    LINK_COPIED: 'Lien copié'
  },
  TOOLTIP: {
    MONTH: 'Mois',
    NAME: 'Nom',
    YEAR: 'Année'
  }
};
